import JSZip from "../../../_snowpack/pkg/@progress/jszip-esm.js";
import * as FileSaver from "../../../_snowpack/pkg/file-saver.js";
import {Dates, Texts, LegalEntityType, Translations} from "../../../_snowpack/link/dist/@salaxy/core/salaxy-lib-core.js";
import {EditDialogKnownActions} from "../../../_snowpack/link/dist/@salaxy/ng1/salaxy-lib-ng1.js";
export class HouseholdYearProController {
  constructor(householdYearsApi, uiHelpers, proService, $timeout, $q, $http) {
    this.householdYearsApi = householdYearsApi;
    this.uiHelpers = uiHelpers;
    this.proService = proService;
    this.$timeout = $timeout;
    this.$q = $q;
    this.$http = $http;
    this.logicalDate = `${this.getYear()}-01-01`;
    this.getODataFilter = () => {
      return `logicalDate eq ${this.logicalDate}`;
    };
  }
  $onInit() {
  }
  async checkYear() {
    const result = await this.uiHelpers.showConfirm(Translations.get("SALAXY.UI_Terms.wait"), Translations.get("SALAXY.PRO.HouseHoldYearComponent.checkYear.initial.text"));
    if (result) {
      const loading = this.uiHelpers.showLoading(Translations.get("SALAXY.UI_Terms.wait"), Translations.get("SALAXY.PRO.HouseHoldYearComponent.checkYear.result.text"));
      const households = await this.getMissingHouseholdsForYear();
      let counter = 0;
      for (const household of households) {
        counter++;
        loading.setText(`${Translations.get("SALAXY.PRO.HouseHoldYearComponent.checkYear.checking")} ${counter}/${households.length}
${household.ownerInfo.avatar.displayName}`);
        await this.checkYearForHousehold(household);
      }
      loading.dismiss();
    }
  }
  async updateProcessingStatus(items) {
    const result = await this.uiHelpers.openEditDialog("/views/pro/modals/household-year-processing-status-dialog.html", {processingStatus: null}, null);
    if (result.action == EditDialogKnownActions.Ok) {
      const newProcessingStatus = result.item.processingStatus;
      const loading = this.uiHelpers.showLoading(Translations.get("SALAXY.UI_Terms.wait"), Translations.get("SALAXY.PRO.HouseHoldYearComponent.updateProcessingStatus.result.text"));
      let counter = 0;
      for (const item of items) {
        counter++;
        loading.setText(`${Translations.get("SALAXY.PRO.HouseHoldYearComponent.updateProcessingStatus.updating")} ${counter}/${items.length}
${item.ownerInfo.avatar.displayName}`);
        await this.updateProcessingStatusForHousehold(item, newProcessingStatus);
      }
      loading.dismiss();
    }
  }
  async export(items) {
    const loading = this.uiHelpers.showLoading(Translations.get("SALAXY.UI_Terms.wait"), Translations.get("SALAXY.PRO.HouseHoldYearComponent.export.loader.text"));
    const results = [];
    let counter = 0;
    for (const item of items) {
      counter++;
      loading.setText(`${Translations.get("SALAXY.PRO.HouseHoldYearComponent.export.loading")} ${counter}/${items.length}
${item.ownerInfo.avatar.displayName}`);
      const pdfs = await this.downloadReportsForHousehold(item);
      results.push(...pdfs);
    }
    if (results.length === 0) {
      loading.dismiss();
    } else {
      if (results.length === 1) {
        this.uiHelpers.downloadFile(results[0].blob, results[0].fileName);
        loading.dismiss();
      } else {
        loading.setText(Translations.get("SALAXY.PRO.HouseHoldYearComponent.export.creatingZipFile"));
        const zip = new JSZip();
        results.forEach((item) => {
          zip.file(`${item.fileName}`, item.blob);
        });
        const blob = await zip.generateAsync({
          type: "blob",
          mimeType: "application/zip"
        });
        FileSaver.saveAs(blob, `${Texts.escapeFileName(`14B_${Dates.format(new Date(), "YYYYMMDD")}`)}.zip`);
        loading.dismiss();
      }
    }
  }
  async getMissingHouseholdsForYear() {
    const year = this.getYear();
    const existingHouseholdYears = [];
    const page = 500;
    const baseLink = `pro/household-years?$filter=logicalDate eq ${year}-01-01T00:00:00Z`;
    let nextLink = `${baseLink}&$skip=${existingHouseholdYears.length}&$top=${page}`;
    while (nextLink) {
      const queryResult = await this.proService.getJSON(nextLink);
      existingHouseholdYears.push(...queryResult.items);
      if (queryResult.items.length == page) {
        nextLink = `${baseLink}&$skip=${existingHouseholdYears.length}&$top=${page}`;
      } else {
        nextLink = null;
      }
    }
    const customerSearch = await this.proService.getJSON(`pro/customers/${year}-01-01?periodType=year`);
    return customerSearch.items.filter((x) => x.ownerInfo.avatar.entityType == LegalEntityType.Person && x.payment > 0 && !existingHouseholdYears.find((h) => h.ownerId === x.ownerId));
  }
  async checkYearForHousehold(household) {
    const householdYear = this.householdYearsApi.getBlank();
    householdYear.year = this.getYear();
    const method = `/v03/api/household-years`;
    try {
      return await this.proService.postJSONFor(household.ownerId, method, householdYear);
    } catch (error) {
      console.error(error);
      return Promise.resolve(null);
    }
  }
  updateProcessingStatusForHousehold(item, processingStatus) {
    const method = `/v03/api/household-years/${item.id}/processingStatus/${processingStatus}`;
    return this.proService.postJSONFor(item.ownerId, method, null);
  }
  async downloadReportsForHousehold(item) {
    const method = `/v03/api/household-years/${item.id}/pdfs?signature=${encodeURIComponent("Asiakkaan puolesta Rakennusliitto ry")}`;
    const pdfs = await this.proService.getJSONFor(item.ownerId, method);
    const results = [];
    for (const pdf of pdfs) {
      results.push({
        fileName: pdf.fileName,
        blob: this.uiHelpers.bytes2Blob(pdf.bytes, "application/pdf")
      });
    }
    return results;
  }
  getYear() {
    const now = new Date();
    const year = now.getMonth() >= 2 ? now.getFullYear() : now.getFullYear() - 1;
    return year;
  }
}
HouseholdYearProController.$inject = [
  "HouseholdYears",
  "UiHelpers",
  "ProService",
  "$timeout",
  "$q",
  "$http"
];
